<template lang="pug">
    .container-fluid.recruit
        .row.recruit__inner
            .col-12.col-md-6.recruit__left
                .recruit__title
                    | {{header}}
                .recruit__items(v-if="jobs")
                    .job(v-for="job, index in jobs")
                        router-link(:to="'jobs/' + job.id")
                            span.job__title
                                | {{job.title}}
                            span.job__detail(v-if="job.categories.length > 0") {{ job.categories[0].name }}
                            span.job__arrow
                                img(src="../assets/home/icon__arrow-right.png")
                .recruit__more
                    router-link(to="jobs").button.button-rounded
                        | {{btn_more_jobs}}
            .col-12.col-md-6.recruit__right
                a(:href="href")
                    img(v-bind="image")
</template>

<script>
    export default {
        name: "WidgetRecruit",
        props: {
            header: String,
            image: Object,
            jobs: Array,
            btn_more_jobs: String,
            href: String,
        }
    };
</script>

<style lang="sass" scoped>
    @import "../../node_modules/bootstrap/scss/functions"
    @import "../assets/styles/CustomVariables"
    @import "../assets/styles/wysiwyg"
    @import "../assets/styles/common"
    @import "../../node_modules/bootstrap/scss/variables"
    @import "../../node_modules/bootstrap/scss/mixins"
    // @import "../../node_modules/bootstrap/scss/reboot"
    @import "../../node_modules/bootstrap/scss/grid"
    $color-blue: #03d3bf
    $color-text: #333333
    .recruit
        background: #f8f8f8

        @include media-breakpoint-between(lg, xl)
            &__items
                padding-bottom: 7rem

        &__inner
            @extend .container
            position: relative
            margin: 2rem auto
            padding-top: 5rem
            padding-bottom: 5rem
            @include media-breakpoint-down(md)
                padding-top: 2rem
                padding-bottom: 2rem
                padding-left: 0
                padding-right: 0

        &__title
            font-weight: bold
            font-size: 3rem
            padding-bottom: 2rem
            border-bottom: 2px solid #e2e2e2
            @include media-breakpoint-down(md)
                padding-bottom: 1rem
                font-size: 1.56rem

        &__more
            position: absolute
            left: 15px
            bottom: 0
            @include media-breakpoint-down(md)
                position: relative
                left: auto
                margin-top: 1rem

        &__right
            text-align: right
            @include media-breakpoint-down(md)
                padding-left: 0
                padding-right: 0

        &__left
            @include media-breakpoint-down(md)
                min-height: 10rem
                padding-left: 0
                padding-right: 0
                margin-bottom: 2rem

    .job
        position: relative
        padding: 2rem 0
        border-bottom: 1px solid #e2e2e2
        @include media-breakpoint-down(md)
            padding: 1rem 0

        &__title
            display: inline-block
            width: 100%
            font-size: 1.875rem
            color: $color-blue
            padding-right: 2.5rem
            @include media-breakpoint-down(md)
                font-size: 1.375rem

        &__detail
            display: inline-block
            width: 100%
            font-size: 1.25rem
            color: $color-text

        &:hover .job__arrow
            right: 0

        &__arrow
            position: absolute
            right: 10px
            transition: right .25s
            top: 50%
            transform: translateY(-50%)
            text-align: right


            img
                @include media-breakpoint-down(md)
                    transform: scale(.5)

    .button-rounded
        &:before
            display: block
            content: " "
            position: absolute
            z-index: 1
            background: black
            border-radius: 2rem
            top: 0
            left: 0
            right: 0
            bottom: 0
            opacity: 0
            transition: opacity .25s
        &:hover:before
            opacity: 0.1
        padding: 1rem 4rem
</style>
